import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';

export default function useClients() {
  const [clients, setClients] = useState([]);
  useEffect(() => {
    axios.get(`${API_BASE_URL}/clients`)
      .then(res => setClients(res.data))
      .catch(() => setClients([]));
  }, []);
  return clients;
}
